//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';

import theme from './ButtonSwitch.scss';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import {
    PopoverTriggerEnum,
    PopoverPlaceEnum
} from 'common/components/core/popover/popOverFactory';
import { translate } from 'react-i18next';

class ButtonSwitch extends React.PureComponent {
    handleVerify = (...args) => {
        this.handleChange({ isVerified: true }, ...args);
    };

    handleIgnore = (...args) => {
        this.handleChange({ isVerified: false }, ...args);
    };

    handleChange = ({ isVerified }, ...args) => {
        const { fieldId, onChange } = this.props;
        onChange && onChange({ isVerified, fieldId }, ...args);
    };

    render() {
        const {
            theme,
            className,
            isVerified,
            isIgnored,
            verifyBtnTooltip,
            ignoreBtnTooltip
        } = this.props;
        return (
            <div
                className={classnames(theme.buttonSwitch, className, {
                    [theme.isVerified]: isVerified,
                    [theme.isIgnored]: isIgnored
                })}
            >
                <ButtonWithPopover
                    buttonType={ButtonTypes.Icon}
                    icon="tickmark"
                    onClick={this.handleVerify}
                    theme={theme}
                    className={theme.verifyBtn}
                    triggerPopoverOn={PopoverTriggerEnum.Hover}
                    place={PopoverPlaceEnum.Above}
                    popOverContent={verifyBtnTooltip}
                    testId="verify"
                />
                <ButtonWithPopover
                    buttonType={ButtonTypes.Icon}
                    icon="cancel-thin"
                    onClick={this.handleIgnore}
                    theme={theme}
                    className={theme.ignoreBtn}
                    triggerPopoverOn={PopoverTriggerEnum.Hover}
                    place={PopoverPlaceEnum.Above}
                    popOverContent={ignoreBtnTooltip}
                    testId="ignore"
                />
            </div>
        );
    }
}

const ThemedButtonSwitch = translate()(
    themr('ButtonSwitch', theme)(ButtonSwitch)
);
export { ThemedButtonSwitch as ButtonSwitch };
export default ThemedButtonSwitch;
